import { AdvancedLocationInputV2FormFields } from '@shared/components/LocationInputV2';
import { LocationInfo } from '@shared/components/LocationVenueSyncDialog/LocationVenueSyncDialog';

type LocationInput = AdvancedLocationInputV2FormFields | LocationInfo;

const getState = (location: LocationInput): string | undefined | null => {
  // Disambiguate which type we are handling, since the two types do not overlap fields
  if ('stateProvince' in location) {
    return location.stateProvince;
  }
  if ('state' in location) {
    return location.state;
  }
  return undefined;
};

export const formatLocationLabel = (location?: LocationInput | null): string => {
  if (!location) return '';

  const { city, country } = location;
  const state = getState(location);

  return [city, state ?? country].filter(Boolean).join(', ');
};
